<div class="add-job-title-dialog">
    <div class="top-right-x">
        <i class="fal fa-times" (click)="closeClickedHandler()"></i>
    </div>
    <div class="add-job-title-title">
        Create new Job Title Mapping.
    </div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="job-title-mapping-row">
            <div class="job-title-form-label">Job Title*</div>
            <div class="job-title-form-input-div">
                <input
                    type="text"
                    id="jobTitleInput"
                    [ngClass]="{
                        'job-title-form-input': true,
                        'input-text-error': jobTitle.errors && (jobTitle.dirty || jobTitle.touched)
                    }"
                    formControlName="jobTitle"
                    (blur)="jobTitleChangeHandler()"
                    maxlength="100"
                />
            </div>
            <div
                *ngIf="
                    jobTitle.errors &&
                    jobTitle.errors.required &&
                    (jobTitle.dirty || jobTitle.touched)
                "
                class="errors"
            >
                * Required
            </div>
            <div *ngIf="jobTitleIsNotUnique" class="errors">
                * Already exists.
            </div>
        </div>
        <div class="job-title-mapping-row">
            <div class="job-title-form-label">Job Code</div>
            <div class="job-title-form-input-div">
                <input
                    type="text"
                    [ngClass]="{
                        'job-title-form-input': true,
                        'input-text-error': jobCode.errors && (jobCode.dirty || jobCode.touched)
                    }"
                    formControlName="jobCode"
                    maxlength="5"
                />
            </div>
            <div
                *ngIf="
                    jobCode.errors && jobCode.errors.required && (jobCode.dirty || jobCode.touched)
                "
                class="errors"
            >
                * Required
            </div>
        </div>
        <div class="job-title-mapping-row">
            <div class="job-title-form-label">Position*</div>
            <div class="job-title-form-input-div">
                <select
                    [ngClass]="{
                        'job-title-form-input-ddl': true,
                        'input-text-error':
                            staffPositionKey.errors &&
                            (staffPositionKey.dirty || staffPositionKey.touched)
                    }"
                    formControlName="staffPositionKey"
                    style="width: 170px;"
                >
                    <option
                        *ngFor="let staffPosition of staffPositions"
                        [value]="staffPosition.staffPositionKey"
                    >
                        {{ staffPosition.position }}
                    </option>
                </select>
            </div>
            <div
                *ngIf="
                    staffPositionKey.errors &&
                    staffPositionKey.errors.required &&
                    (staffPositionKey.dirty || staffPositionKey.touched)
                "
                class="errors"
            >
                * Required
            </div>
        </div>
        <div class="add-job-title-buttons">
            <button
                mat-button
                outlined
                class="btn-button"
                (click)="closeClickedHandler()"
                type="button"
            >
                CANCEL
            </button>
            <button
                mat-button
                primary
                [disabled]="!form.valid || form.pristine || jobTitleIsNotUnique"
                class="btn-button"
            >
                SAVE
                <i class="fa fa-spinner fa-spin" *ngIf="submitting"></i>
            </button>
        </div>
    </form>
</div>
